import { FC, memo } from 'react'
import {
    FooterGroup,
    FooterGroupsContainer,
    FooterLinkItem,
    FooterLinksContainer,
    Slide,
    Title,
} from './footer-group-section-styles'
import ExternalLink from '../../../common/external-link'
import { FooterGroupTransport } from '../../../../transports/common/footer-section-transport'

interface FooterGroupProps {
    footerGroups: FooterGroupTransport[]
}

const FooterGroupSection: FC<FooterGroupProps> = ({ footerGroups }) => {
    return (
        <FooterGroupsContainer>
            {footerGroups.map(item => (
                <FooterGroup key={item.groupName}>
                    <Title>{item.groupName}</Title>
                    <FooterLinksContainer>
                        {item.footerLinkItems.map(bigItem => (
                            <FooterLinkItem key={bigItem.text}>
                                <ExternalLink
                                    as={Slide}
                                    title={bigItem.text}
                                    href={bigItem.url}
                                    noCrawl={bigItem.noCrawl}
                                >
                                    {bigItem.text}
                                </ExternalLink>
                            </FooterLinkItem>
                        ))}
                    </FooterLinksContainer>
                </FooterGroup>
            ))}
        </FooterGroupsContainer>
    )
}

export default memo(FooterGroupSection)
